
var showTooltip = false;

// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.limit,
        /* Optional */
        loadProductFirst: false,
        //hasBestSellingSort: true,
    },
};

// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<div class="product-card {{itemHighlightClass}}">' +
                                '<a class="product-card__link" href="{{itemUrl}}">' +
                                    '<span class="visually-hidden">{{itemTitle}}</span>' +
                                '</a>' +
                                '<div class="tags-titles">' +
                                    '{{itemTags}}' +
                                '</div>' +
                                '<div class="product-card__image-wrapper">' +
                                    '<img class="product-card__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                    '<img class="product-card__image--hover" src="{{hoverThumbUrl}}" alt="{{itemTitle}}">' +
                                '</div>' +
                                '{{itemFormattedTitle}}' +
                                // '{{itemPrice}}' +
                                '{{itemColorsCounter}}' +
                            '</div>',


    // Pagination Template
    'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}"><svg xmlns="http://www.w3.org/2000/svg" width="9.077" height="15.326" viewBox="0 0 9.077 15.326"><path id="Path_6" data-name="Path 6" d="M3109,374.934l6.956,6.956,6.956-6.956" transform="translate(383.304 -3108.293) rotate(90)" fill="none" stroke="currentColor" stroke-width="2"></path></svg></a></span>',
    'previousDisabledHtml': '<span class="prev"><a href="" disabled><svg xmlns="http://www.w3.org/2000/svg" width="9.077" height="15.326" viewBox="0 0 9.077 15.326"><path id="Path_6" data-name="Path 6" d="M3109,374.934l6.956,6.956,6.956-6.956" transform="translate(383.304 -3108.293) rotate(90)" fill="none" stroke="currentColor" stroke-width="2"></path></svg></a></span>',
    'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}"><svg xmlns="http://www.w3.org/2000/svg" width="8.414" height="14.828" viewBox="0 0 8.414 14.828"><path d="M9,18l6-6L9,6" transform="translate(-7.586 -4.586)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg></a></span>',
    'nextDisabledHtml': '<span class="next"><a href="" disabled><svg xmlns="http://www.w3.org/2000/svg" width="8.414" height="14.828" viewBox="0 0 8.414 14.828"><path d="M9,18l6-6L9,6" transform="translate(-7.586 -4.586)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg></a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="page">{{itemTitle}}</span></li>',
    'paginateHtml': '<div class="pagination__container">{{previous}}{{pageItems}}{{next}}</div>',
  
    // Sorting Template
    'sortingHtml': '{{sortingItems}}'
};

// Used to show only ONE highlighted product in a product listing (collection, search, etc);
var is_highlighted_shown = false;
// var allProducts = bcSfFilterConfig.custom.allProducts;
var colorContainer, colorLabels;

var ecoLabel = bcSfFilterConfig.custom.eco_label;
var floatingLabel = bcSfFilterConfig.custom.floating_label;
var influencerLabel = bcSfFilterConfig.custom.influencer_label;
var storefrontAccessToken = bcSfFilterConfig.custom.storefront_access_token;

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
    var highlightClass = '';
    // Get Template if the product is highlighted or not
    if(data.tags.includes('highlight') && !is_highlighted_shown) {
        highlightClass = 'product-card--featured';
        is_highlighted_shown = true;
    }

    itemHtml = itemHtml.replace(/{{itemHighlightClass}}/g, highlightClass);

    var itemAllTags = data.tags;

    // Add badges according to badge: tag
    var is_eco_product, ecoLeafSvg = '';
    var is_floating_product, floatingIconSvg = '';
    var is_influencer_product, influencerIconSvg = '';

    if(itemAllTags) {
        is_eco_product = itemAllTags.some(itemTag => itemTag.includes('badge: eco'));
        is_floating_product = itemAllTags.some(itemTag => itemTag.includes('badge: floating'));
        is_influencer_product = itemAllTags.some(itemTag => itemTag.includes('badge: influencer'));
    }

    if(is_eco_product) {
        ecoLeafSvg = '<span data-tooltip="' + ecoLabel + '" data-tooltip-badge>' + 
                        '<svg xmlns="http://www.w3.org/2000/svg" width="17.404" height="18.7" viewBox="0 0 17.404 18.7">' +
                            '<path id="Subtraction_2" data-name="Subtraction 2" d="M-3709.147-32.3a11.326,11.326,0,0,1-9.063-3.961,12.968,12.968,0,0,1-2.431-4.819,17.187,17.187,0,0,1-.565-4.712,20,20,0,0,1,.683-5l.006,0a16.62,16.62,0,0,1,2.732-.207,17.483,17.483,0,0,1,5.323.79,12.8,12.8,0,0,1,5.647,3.547,11.493,11.493,0,0,1,2.958,6.939,16.584,16.584,0,0,1-.515,5.557l-10.035-11.146a1,1,0,0,0-.743-.33,1,1,0,0,0-.669.257,1,1,0,0,0-.074,1.413l10.191,11.318A17.166,17.166,0,0,1-3709.147-32.3Z" transform="translate(3721.208 51)" fill="#77c000"/>' +
                        '</svg>' +
                        '<span class="tooltip-arrow"></span>' +
                    '</span>';
    }

    if(is_floating_product) {
        floatingIconSvg =   '<span data-tooltip="' + floatingLabel + '" data-tooltip-badge>' + 
                                '<svg xmlns="http://www.w3.org/2000/svg" width="31.296" height="17.836" viewBox="0 0 31.296 17.836">' +
                                    '<path id="floating-icon" d="M-1998.926-34.619c-3.453-1.327-7.441-2.653-13.074.354,7.225-9.3,11.694-7.642,16.061-5.989,3.652,1.382,7.233,2.765,12.3-2.253-3.921,7.346-6.921,9.356-9.853,9.357A15.785,15.785,0,0,1-1998.926-34.619Zm2.915-8.483c-3.562-1.319-7.721-2.636-14.048,1.239,7.5-10.8,12.2-9.025,16.911-7.246,3.693,1.4,7.391,2.791,12.443-1.878-4.216,7.258-7.269,9.212-10.174,9.213A15.26,15.26,0,0,1-1996.011-43.1Z" transform="translate(2012 50.988)" fill="#068adc"/>' +
                                '</svg>' +
                                '<span class="tooltip-arrow"></span>' +
                            '</span>';
    }

    if(is_influencer_product) {
        influencerIconSvg = '<span data-tooltip="' + influencerLabel + '" data-tooltip-badge>' + 
                                '<svg style="vertical-align: bottom" xmlns="http://www.w3.org/2000/svg" width="19.002" height="24" viewBox="0 0 19.002 24">' +
                                    '<path id="influencer-choice-icon" d="M-2007-28a5.006,5.006,0,0,1-5-5v-9a5.006,5.006,0,0,1,5-5h9a5.006,5.006,0,0,1,5,5v9a5.006,5.006,0,0,1-5,5Zm-2-9.5a6.508,6.508,0,0,0,6.5,6.5,6.508,6.508,0,0,0,6.5-6.5,6.507,6.507,0,0,0-6.5-6.5A6.507,6.507,0,0,0-2009-37.5Zm2,0a4.505,4.505,0,0,1,4.5-4.5,4.505,4.505,0,0,1,4.5,4.5,4.505,4.505,0,0,1-4.5,4.5A4.505,4.505,0,0,1-2007-37.5Zm-5-12.5a2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2A2,2,0,0,1-2012-50Z" transform="translate(2012 52)" fill="#f778e3"/>' +
                                '</svg>' +
                                '<span class="tooltip-arrow"></span>' +
                            '</span>';
    }

    var productTitle = '<div class="product-card__title-wrapper"><div class="product-card__badges">' + ecoLeafSvg + floatingIconSvg + influencerIconSvg + '</div><h3 class="product-card__title">' + data.title + '</h3></div>';

    // Add 2 Tags
    // First we check about tag that have title new:
    // Then we need only the tags that have the title tag:
    var itemTags = [];
    var newTag = '';
    var limitTags = 2;

    if(itemAllTags) {
        itemAllTags.forEach(itemTag => {
            if(itemTag.includes('new: ')) {
                newTag = itemTag.split('new: ')[1];
            }

            if(itemTag.includes('tag')) {
                itemTags.push(itemTag.split('tag: ')[1]);
            }
        })
    };

    var tagsHTML = '';
    var tagsShown = 0;

    if(newTag != '') {
        tagsHTML += '<span class="tags-titles__title tags-titles__title--red">' + newTag + '</span>';
        tagsShown++;
    }

    if(itemTags) {
        itemTags.forEach(itemTag => {
            if(tagsShown < limitTags) {
                tagsHTML += '<span class="tags-titles__title">' + itemTag + '</span>';
                tagsShown++;
            }
        });
    };

    itemHtml = itemHtml.replace(/{{itemTags}}/g, tagsHTML);

    var hasHoverImage = false;
    if(images.length > 1) {
        hasHoverImage = true;
    }

    if(hasHoverImage) {
        // Add Thumbnail
        var itemThumbUrl = images.length > 1 ? this.optimizeImage(images[1]['src']) : bcSfFilterConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

        // Add hover thumbnail
        var hoverThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{hoverThumbUrl}}/g, hoverThumbUrl);
    } else {
        // Add Thumbnail
        var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
        itemHtml = itemHtml.replace(/{{hoverThumbUrl}}/g, itemThumbUrl);
    }

    // Add Price
    var prevPrice = data.compare_at_price_min;
    var itemPriceHTML = '<div class="product-card__prices">';
    // Add previous price if it has
    if(prevPrice) {
        var currency = this.formatMoney(prevPrice).substr(0, 1); // Couldn't find a better way, data didn't provide the store currency
        var priceAmount = prevPrice.toString().split('.')[0];
        var priceAmountAfterSeparator = prevPrice.toString().split('.')[1] || '00';
        var priceSeparator = '.' // Taken from Shopify settings

        itemPriceHTML += '<div class="product-card__price product-card__price--prev">' +
                                '<span class="product-card__price__currency">' + currency + '</span>' +
                                '<span class="product-card__price__amount">' + priceAmount + '</span>' +
                                '<span class="product-card__price__separator">' + priceSeparator + '</span>' +
                                '<span class="product-card__price__after-comma">' + priceAmountAfterSeparator + '</span>' +
                            '</div>';
    }

    // Add current price
    var currency = this.formatMoney(data.price_min).substr(0, 1); // Couldn't find a better way, data didn't provide the store currency
    var priceAmount = data.price_min.toString().split('.')[0];
    var priceAmountAfterSeparator = data.price_min.toString().split('.')[1] || '00';
    var priceSeparator = '.' // Taken from Shopify settings

    itemPriceHTML += '<div class="product-card__price">' +
                            '<span class="product-card__price__currency">' + currency + '</span>' +
                            '<span class="product-card__price__amount">' + priceAmount + '</span>' +
                            '<span class="product-card__price__separator">' + priceSeparator + '</span>' +
                            '<span class="product-card__price__after-comma">' + priceAmountAfterSeparator + '</span>' +
                        '</div>';

    itemPriceHTML += '</div>';

    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHTML);

    if(storefrontAccessToken != '') {
        fillColorsCounter(data.title, index);
    }

    // Add color counter
    colorCounterHTML = '<span class="product-card__colors"><span class="js-color-container"></span> <span class="js-color-label"></span></span>';

    itemHtml = itemHtml.replace(/{{itemColorsCounter}}/g, colorCounterHTML);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemFormattedTitle}}/g, productTitle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    // If it's the last product in a listing, change the variable
    // back to false value, so it can be ready for the next listing
    if(index == bcSfFilterSettings.general.limit) {
        is_highlighted_shown = false;
    }

    return itemHtml;
};

function fillColorsCounter(title, index) {
    var productsTotal;
    var escapeCharsTitle = '\\"'+title+'\\"';

    fetch('/api/graphql',{
        method: 'POST',
        headers: {
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            'Content-Type': 'application/graphql',
        },
        body: `{
            products(first: 40, query: "${escapeCharsTitle}" ) {
                edges {
                    node {
                        id
                        title
                    }
                }
            }    
        }`})
        .then(response => response.json())
        .then(returnedData => {
            productsTotal = returnedData.data.products.edges.length;

            var colorLabel = bcSfFilterConfig.custom.singular_color_label;

            if(productsTotal > 1) {
                colorLabel = bcSfFilterConfig.custom.plural_color_label;
            }
            
            colorContainer[index - 1].innerText = productsTotal;
            colorLabels[index - 1].innerText = colorLabel;
        });
}

/************************** END BUILD PRODUCT LIST **************************/

function clearAllFilterOptions(event) {	
    event.preventDefault();	
    bcsffilter.internalClick = true;	
    // Get current params	
    var currentParams = window.location.search.substr(1).split('&');	
		
    // Build new params	
    var newParams = [];	
    for (var k = 0; k < currentParams.length; k++) {	
        if ((currentParams[k].indexOf('sort=') > -1 && currentParams[k].indexOf('pf_') === -1) 	
        || (currentParams[k].indexOf('display=') > -1 && currentParams[k].indexOf('pf_') === -1) 	
        || (currentParams[k].indexOf('q=') > -1 && currentParams[k].indexOf('pf_') === -1)) {	
            newParams.push(currentParams[k]);	
        }	
    }	
    // Build url	
    var newUrl = window.location.href.split('?')[0];	
    if (newParams.length > 0) newUrl += '?' + newParams.join('&');	
		
  	jQ('.collection__selected-filters').find('.bc-sf-filter-pc').remove();	
    // Fire event	
    bcsffilter.onChangeData(newUrl, 'clearAllFilterOptions');	
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    
    colorContainer = document.querySelectorAll('.js-color-container');
    colorLabels = document.querySelectorAll('.js-color-label');

    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('..');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('..');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] === '..') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Pagination event
BCSfFilter.prototype.buildPaginationEvent = function(data) {
    var _this = this;
    var currentPage = parseInt(this.queryParams.page);

    // Build Pagination event
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Build event
        jQ(this.selector.bottomPagination).find('a').unbind('click');
        jQ(this.selector.bottomPagination).find('a').on('click', function(e) {
            e.preventDefault();
            _this.internalClick = true;
            var newUrl = jQ(this).attr('href');
            _this.onChangeData(newUrl, 'page');
            jQ('body,html').animate({
                scrollTop: jQ(_this.getSelector('products')).position().top - jQ('.js-main-header-nav').height()
            }, 600);
        });
    } else {
        // Using scrolling to prevent callling onscroll twice
        var scrolling = 0;

        // onscroll event
        // When windown reaches the bottom of product list, load more
        jQ(window).scroll(function(e) {
            e.preventDefault();
            e.stopPropagation();

            var maxPos = parseInt(jQ(_this.getSelector('products')).offset().top) + parseInt(jQ(_this.getSelector('products')).outerHeight(true));
            var maxScroll = parseInt(jQ(window).scrollTop()) + _this.getSettingValue('general.positionShowInfiniteLoading');
            // Load earlier for large screen
            if (jQ(window).width() > 5000) maxScroll = maxScroll + 2000;
            else if (jQ(window).width() > 2500) maxScroll = maxScroll + 800;
            else if (jQ(window).width() > 1400) maxScroll = maxScroll + 200;
            // Begin loading more products
            if (scrolling == 0 && maxScroll >= maxPos && data.products.length > 0) {
                // Show Loading
                _this.showLoadMoreLoading();

                // Prevent scrolling twice
                scrolling = 1;

                // Next page
                currentPage ++;

                // Build data of next page
                _this.internalClick = true;
                _this.queryParams.limit = _this.getSettingValue('general.limit');
                _this.queryParams.page = currentPage;
                _this.getFilterData('page');
            }
        });
    }
};

/************************** BUILD TOOLBAR **************************/

// // Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ('#bc-sf-filter-top-sorting').html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<li class="sort manual"><a href="' + k + '" data-sort="manual"><span class="brackets skeleton-loading" data-trans-key="collections.sorting.manual">' + sortingArr[k] + '</span></a></li>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ('#bc-sf-filter-top-sorting').html(html);
        }

        var _this = this;
        jQ('#bc-sf-filter-top-sorting li a').each(function() {
            if (_this.queryParams.sort == jQ(this).attr('href')) {
                jQ('#order-label-selected').text(jQ(this).text());
            }
        });
    }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
    var _this = this;
    jQ('#bc-sf-filter-top-sorting li a').click(function(e) {
        onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).attr('href'));
    })
};

/************************** END BUILD TOOLBAR **************************/

		
// Add additional feature for product list, used commonly in customizing product list	
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {	
};	
// Build Additional Elements	
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {	
  var totalProduct = '';	
  if (data.total_product == 1) {	
    totalProduct = data.total_product + ' ' + 'Product';	
  } else {	
    totalProduct = data.total_product+ ' ' + 'Products';	
  }	
  totalProduct = jQ.parseHTML(totalProduct);	
  jQ('#bc-sf-filter-total-product').html(totalProduct);	
  
  var filtersSelected = jQ('.bc-sf-filter-pc').html();	
  jQ('.bc-sf-filter-pc').remove();	

  if(filtersSelected) {
    jQ('.collection__selected-filters').append('<div class="bc-sf-filter-pc bc-sf-filter-selection-wrapper">' + filtersSelected + '</div>');	
  }
};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e);if(i!=this.selector.filterTree&&i!=this.selector.filterTreeHorizontal&&jQ(i).html(""),void 0===i)i="vertical"==t?this.selector.filterTree:this.selector.filterTreeHorizontal;void 0!==r&&"before"==r?jQ(i).prepend(e):jQ(i).append(e)};
/* End Fix version 2.3.2 */

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */